import './injectReducers';
import { createSelector } from 'reselect';
import { ReduxState } from '../state';
import { IdentitySessionState } from './types';
import { INITIAL_STATE } from './reducers';

export const selectIdentitySession = (
  state: ReduxState
): IdentitySessionState => state.IdentitySession || INITIAL_STATE;

export const selectShowFaceCheckModal = createSelector(
  selectIdentitySession,
  (identitySession): boolean => {
    return identitySession.showFaceCheckModal;
  }
);

export const selectLoading = createSelector(
  selectIdentitySession,
  (identitySession): boolean => {
    return identitySession.loading;
  }
);

export const selectError = createSelector(
  selectIdentitySession,
  (identitySession): string | null => {
    return identitySession.error;
  }
);
